// Day/night switch. Night is the theme palette; day is the chalk-paper override in styles.css
// keyed on <html data-scheme="day">. The choice persists in localStorage; an inline head script
// applies it before first paint so the page never flashes the wrong scheme.
const STORAGE_KEY = 'wane-scheme';

class SchemeToggle extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      const next = document.documentElement.dataset.scheme === 'day' ? 'night' : 'day';
      if (next === 'day') document.documentElement.dataset.scheme = 'day';
      else delete document.documentElement.dataset.scheme;
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // Private mode: the switch still works for this page view.
      }
      this.#sync();
    }, { signal: this.#abort.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #sync() {
    const day = document.documentElement.dataset.scheme === 'day';
    const button = this.querySelector('button');
    if (!button) return;
    button.setAttribute('aria-pressed', String(day));
    button.setAttribute('aria-label', day ? button.dataset.labelNight : button.dataset.labelDay);
    button.setAttribute('title', day ? button.dataset.labelNight : button.dataset.labelDay);
  }
}

if (!customElements.get('s-scheme-toggle')) customElements.define('s-scheme-toggle', SchemeToggle);
